import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';

import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';

import ModalToBody from '../../../base/ModalToBody';
import { ajaxErrorHandler, defaultSuccess } from '../../../libs/utils';
import { updateRegistrationParking } from '../../../services/api/registrationParkings';

class ParkingsOverviewButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };

    this._closeModal = this._closeModal.bind(this);
    this._openModal = this._openModal.bind(this);
    this._limitChange = this._limitChange.bind(this);
  }

  static propTypes = {
    limits: PropTypes.array,
    admin: PropTypes.bool,
  };

  _closeModal() {
    this.setState({ showModal: false });
  }

  _openModal() {
    this.setState({ showModal: true });
  }

  _limitChange(day, limit, e) {
    let found = false;

    for (let i = 0; i < limit.amountPerDay.length; i++) {
      if (limit.amountPerDay[i].day === day) {
        found = true;
        limit.amountPerDay[i] = {
          ...limit.amountPerDay[i],
          amount: parseInt(e.target.value, 10),
        };
      }
    }

    if (!found) {
      limit.amountPerDay.push({
        day: day,
        amount: parseInt(e.target.value, 10),
      });
    }

    updateRegistrationParking(limit.registrationId, limit.id, limit)
      .then((response) => {
        defaultSuccess('Parking Limit updated.');
      })
      .catch(ajaxErrorHandler);
  }

  render() {
    const { showModal } = this.state;
    const { limits, admin } = this.props;

    return (
      <div>
        <Button onClick={this._openModal} variant="outline" size="sm" disabled={!limits?.length}>
          <Icon icon="eye" />
          <Trans>RegistrationParkingShowOverviewButton</Trans>
        </Button>

        <ModalToBody>
          <div
            className="modal fade show"
            id="m_modal_4"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1039',
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Parking Overview
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this._closeModal}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  {limits && (
                    <table className="table table-striped m-table">
                      <thead>
                        <tr>
                          <th>
                            <Trans>Day</Trans>
                          </th>
                          {limits.map((limit) => (
                            <th key={limit.id}>
                              {limit.parking.name} (daily max {limit.parking.capacity})
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {limits[0]?.enforcedDays.map((day) => (
                          <tr key={day}>
                            <th scope="row">{day}</th>
                            {limits.map((limit) => {
                              const currentLimit = limit.amountPerDay.filter((aday) => aday.day === day)[0];
                              const used = currentLimit?.used ?? 0;
                              const max = currentLimit?.amount ?? 0;

                              const text = (
                                <span>
                                  {used + ' '}
                                  <span className="tableMax">
                                    of max{' '}
                                    {admin ? (
                                      <input
                                        type="number"
                                        defaultValue={max}
                                        onBlur={(e) => this._limitChange(day, limit, e)}
                                        className="form-control"
                                        style={{
                                          display: 'inline-block',
                                          width: 60,
                                        }}
                                      />
                                    ) : (
                                      max
                                    )}
                                  </span>
                                </span>
                              );

                              return <td key={day + limit.id}>{text}</td>;
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            className={'modal-backdrop fade ' + (showModal ? ' show' : '')}
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1038',
            }}
            onClick={this._closeModal}
          />
        </ModalToBody>
      </div>
    );
  }
}

export default ParkingsOverviewButton;
